import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import loadScripts from '../../../dassets/js/custom';
class GuarantorAccount extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            identification: this.refs.identification.value,
            full_name: this.refs.full_name.value,
            entity_name: this.refs.entity_name.value,
            res_reg_add: this.refs.res_reg_add.value,
            guarantor_dob: this.refs.guarantor_dob.value,
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Details of Person/Entity acting on behalf of Applicant (If Applicable)</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Registered name of entity (If company, corporation of trust)</label>
                                            <Form.Control type="text" className="form-control" ref="entity_name" placeholder="Registered name of entity" defaultValue={this.props.fieldValues.entity_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Full Name (Surname First)</label>
                                            <Form.Control type="text" className="form-control" ref="full_name" placeholder="Full Name (Surname First)" defaultValue={this.props.fieldValues.full_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Identification</label>
                                            <select ref="identification" className="form-control" defaultValue={this.props.fieldValues.identification}>
                                                <option value="" hidden>Select...</option>
                                                <option value="International Passport">International Passport</option>
                                                <option value="Driver's Licence">Driver's Licence</option>
                                                <option value="National ID Card">National ID Card</option>
                                                <option value="Permanent Voters Card">Permanent Voters Card</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Birth</label>
                                            <Form.Control type="date" className="form-control" ref="guarantor_dob" placeholder="Date of Birth" defaultValue={this.props.fieldValues.guarantor_dob} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Registered/Residential Address</label>
                                            <Form.Control type="text" className="form-control" ref="res_reg_add" placeholder="Registered/Residential Address" defaultValue={this.props.fieldValues.res_reg_add} />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GuarantorAccount;